import { useLocation } from "react-router-dom";

export function useQueryParam(key: string) {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  return queryParams.get(key);
}
